import { derived, readable } from "svelte/store";
import { ErrorStatus, GameStatus, game } from "./game";
const gameStore = readable(game, (set) => {
    game.subscribe(game => set(game));
});
export const message = derived([gameStore], ([game], set) => {
    switch (game.gameStatus) {
        case GameStatus.Won:
            {
                let n = game.currentRow;
                let word = game.word;
                let plural = n === 1 ? "попытку" : (n > 1 && n < 5 ? "попытки" : "попыток");
                set(`Победа! За ${n} ${plural} угадано слово «${word}»`);
            }
            break;
        case GameStatus.Lost:
            set(`Искомое слово: «${game.word}»`);
            break;
        default: set("");
    }
});
export const alreadySolvedWotdMessage = derived(game, (game, set) => {
    let unsub = game.onAlreadySolvedDay(({ day, currentDay, suggestRandom }) => {
        let u = new URL(window.location.href);
        u.searchParams.set("day", currentDay);
        let ru = new URL(window.location.href);
        ru.searchParams.delete("day");
        ru.searchParams.delete("random");
        set({
            day,
            currentDay,
            currentUrl: u.toString(),
            randomUrl: ru.toString(),
            dismiss: () => set(null),
            suggestRandom,
        });
    });
    return () => unsub();
});
export const errorMessage = derived([gameStore], ([game], set) => {
    switch (game.errorStatus) {
        case ErrorStatus.NotFilled:
            set(`Мало букв`);
            break;
        case ErrorStatus.AlreadyPlayed:
            set(`Уже сыграно`);
            break;
        default: set("");
    }
});
export const notInDictMessage = derived([gameStore], ([game], set) => {
    if (game.errorStatus === ErrorStatus.NotInDictionary) {
        set("Не в словаре");
    }
    else {
        set("");
    }
});
export const shaker = derived([gameStore], ([game], set) => {
    if (game.errorStatus !== ErrorStatus.NoError) {
        set(true);
        let timer = setTimeout(() => {
            set(false);
        }, 300);
        return () => clearTimeout(timer);
    }
}, false);
